import React from 'react'
import { StyleSheet, Text } from 'react-native'
import { liff } from '@line/liff'
import * as COLORS from 'constants/colors'
import { splitByUrls } from './splitByUrls'

const styles = StyleSheet.create({
  linkText: {
    color: COLORS.PRIMARY,
    textDecorationLine: 'underline',
  },
})

/**
 * @content : テキスト内容
 */
interface Props {
  content: string
}

/**
 * テキスト中のURLを検出し、タップで外部ブラウザに遷移可能なリンクとして表示するコンポーネント。
 *
 * @description
 * - URLが含まれない場合は入力内容をそのまま表示する。
 * - リンクタップ時は liff.openWindow() により外部ブラウザで開く。
 */
export function LinkifyText({ content }: Props) {
  const parts = splitByUrls(content)

  return (
    <>
      {parts.map((part, i) =>
        part.type === 'url' ? (
          <LinkifyTextURLItem key={i} url={part.value} />
        ) : (
          <React.Fragment key={i}>{part.value}</React.Fragment>
        ),
      )}
    </>
  )
}

function LinkifyTextURLItem({ url }: { url: string }) {
  const handlePress = () => {
    liff.openWindow({ url, external: true })
  }
  return (
    <Text style={styles.linkText} onPress={handlePress}>
      {url}
    </Text>
  )
}
